module.exports = __webpack_public_path__ + "eaff5ce95a92c87a3be03f3532a1fc58.png";